import { connect } from 'react-redux';

import { alertOccurByIdSelector, alertResByIdSelector } from '../selectors';
import AlertDataModal from '../components/Alerts/AlertDataModal';

const mapStateToProps = (state, { id, type, open, onClose }) => {
  let alert;
  if (type === 'resolved') {
    alert = alertResByIdSelector(state, id);
  } else {
    alert = alertOccurByIdSelector(state, id);
  }

  return {
    alert,
    open,
    onClose,
  };
};

export default connect(mapStateToProps)(AlertDataModal);
